<div>
  <mat-card class="p-4 mb-3">
    <h3 class="my-0 font-weight--500 d-flex mb-3">
      <mat-icon fontSet="material-symbols-outlined">filter_alt</mat-icon>&nbsp;Filters & Zoeken
    </h3>
    <div class="d-flex flex-wrap gap-2">
      <!-- Search -->
      <mat-form-field appearance="outline" class="no-subscript search-form-field">
        <mat-label>Zoek op naam, beschrijving...</mat-label>
        <input [formControl]="searchQueryInput" matInput placeholder="Zoek op naam, beschrijving" value="">
      </mat-form-field>

      <!-- Goal -->
      <mat-form-field appearance="outline" class="no-subscript">
        <mat-label>Doel</mat-label>
        <mat-select [formControl]="goalSelect" multiple>
          @for (goal of goalList; track goal.id) {
            <mat-option [value]="goal">{{ goal.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Reach -->
      <mat-form-field appearance="outline" class="no-subscript">
        <mat-label>Reikwijdte</mat-label>
        <mat-select [formControl]="reachSelect" multiple>
          @for (reach of reachList; track reach.id) {
            <mat-option [value]="reach">{{ reach.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Province -->
      <mat-form-field appearance="outline" class="no-subscript">
        <mat-label>Provincie</mat-label>
        <mat-select [formControl]="provinceSelect" multiple>
          @for (province of provinceList; track province.id) {
            <mat-option [value]="province">{{ province.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Heritage type -->
      <mat-form-field appearance="outline" class="no-subscript">
        <mat-label>Erfgoedtype</mat-label>
        <mat-select [formControl]="heritageTypeSelect" multiple>
          @for (heritageType of heritageTypeList; track heritageType.id) {
            <mat-option [value]="heritageType">{{ heritageType.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Impact type -->
      <mat-form-field appearance="outline" class="no-subscript">
        <mat-label>Impacttype</mat-label>
        <mat-select [formControl]="impactTypeSelect" multiple>
          @for (impactType of impactTypeList; track impactType.id) {
            <mat-option [value]="impactType">{{ impactType.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Status -->
      <mat-form-field appearance="outline" class="no-subscript">
        <mat-label>Status</mat-label>
        <mat-select [formControl]="statusSelect">
          <mat-option [value]="''">Alle statussen</mat-option>
          <mat-option [value]="OrganizationStatus.PUBLISHED">Gepubliceerd</mat-option>
          <mat-option [value]="OrganizationStatus.NOT_PUBLISHED">Concept</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Is active -->
      <div class="d-flex align-items-center mr-2">
        <mat-checkbox [formControl]="isActiveCheckbox">Actief</mat-checkbox>
      </div>

      <!-- Reset -->
      <div class="d-flex align-items-center">
        <button mat-stroked-button (click)="clearFilters()">Wis filters</button>
      </div>
    </div>
  </mat-card>


  <mat-card class="p-4">
    <div class="d-flex flex-row justify-content-between">
      <!-- Title -->
      <div class="d-flex flex-column mb-3">
        <h3 class="my-0 font-weight--500 d-flex">
          <mat-icon fontSet="material-symbols-outlined">groups</mat-icon>&nbsp;Organisaties Overzicht
        </h3>
        <span class="text-muted">{{ dataSource.total$ | async }} organisaties gevonden</span>
      </div>
      <div>

        <!-- Create new organization -->
        <button matButton="filled" routerLink="/create-edit-organization">
          <mat-icon>add</mat-icon>
          Nieuwe Organisatie
        </button>

      </div>
    </div>


    <!-- Table -->
    <!-- Loader -->
    <div class="progress-bar-container">
      @if (dataSource.loading$ | async) {
        <mat-progress-bar
          mode="indeterminate"
        ></mat-progress-bar>
      }
    </div>
    <!-- End loader -->
    <div class="list-container">
      <table mat-table [dataSource]="dataSource" class="w-100">

        <!-- ID -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef> ID</th>
          <td mat-cell *matCellDef="let organization">
            <span class="font-weight--500">{{ organization.slug }}</span>
          </td>
        </ng-container>

        <!-- Name -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>
            <div class="d-flex flex-column">
              <span>Naam</span>
              <span class="text-muted">Beschrijving</span>
            </div>
          </th>
          <td mat-cell *matCellDef="let organization">
            <div class="d-flex flex-column my-1">
              <span class="font-weight--500 mb-1">{{ organization.name }}</span>
              <span class="text-muted">{{ organization.shortDescription | maxWords: 'maxWords':26 }}</span>
            </div>
          </td>
        </ng-container>

        <!-- Contact -->
        <ng-container matColumnDef="contact">
          <th mat-header-cell *matHeaderCellDef>
            Publicatie
          </th>
          <td mat-cell *matCellDef="let organization">
            <div class="d-flex flex-column">
              <span class="font-weight--500">{{ organization.contactName }}</span>
              <span class="text-muted">{{ organization.createdAt | date:'dd/MM/yy' }}</span>
            </div>
          </td>
        </ng-container>

        <!-- Goal -->
        <ng-container matColumnDef="goal">
          <th mat-header-cell *matHeaderCellDef> Doel</th>
          <td mat-cell *matCellDef="let organization">
            <mat-chip-set aria-label="Goal list">
              @for (goal of organization.goalList; track goal.id) {
                <mat-chip
                  class="organization-goal"
                  [style.color]="goalColor(goal).color"
                  [style.background-color]="goalColor(goal).background"
                  [style.border]="'1px solid ' + goalColor(goal).border"
                >
                  {{ goal.name || '-' }}
                </mat-chip>
              }
            </mat-chip-set>
          </td>
        </ng-container>

        <!-- Reach -->
        <ng-container matColumnDef="reach">
          <th mat-header-cell *matHeaderCellDef> Reikwijdte</th>
          <td mat-cell *matCellDef="let organization"> {{ organization.reach?.name }}</td>
        </ng-container>

        <!-- Province -->
        <ng-container matColumnDef="province">
          <th mat-header-cell *matHeaderCellDef>Provincies</th>
          <td mat-cell *matCellDef="let organization">
            <mat-chip-set aria-label="Province list">
              @for (province of organization.provinces; track province.id) {
                <mat-chip>{{ province.name }}</mat-chip>
              }
            </mat-chip-set>
          </td>
        </ng-container>

        <!-- Heritage types -->
        <ng-container matColumnDef="heritageTypes">
          <th mat-header-cell *matHeaderCellDef> Erfgoedtypes</th>
          <td mat-cell *matCellDef="let organization">
            <mat-chip-set aria-label="Heritage type list">
              @for (heritageType of organization.heritageTypes; track heritageType.id) {
                <mat-chip>{{ heritageType.name }}</mat-chip>
              }
            </mat-chip-set>
          </td>
        </ng-container>

        <!-- Impact types -->
        <ng-container matColumnDef="impactTypes">
          <th mat-header-cell *matHeaderCellDef> Impacttypes</th>
          <td mat-cell *matCellDef="let organization">
            <mat-chip-set aria-label="Impact type list">
              @for (impactType of organization.impactTypes; track impactType.id) {
                <mat-chip>{{ impactType.name }}</mat-chip>
              }
            </mat-chip-set>
          </td>
        </ng-container>

        <!-- Status -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let organization">
            @if (organization.status === OrganizationStatus.PUBLISHED) {
              <mat-icon
                fontSet="material-symbols-outlined"
                class="text-success"
                matTooltip="Published"
              >visibility</mat-icon>
            } @else {
              <mat-icon
                fontSet="material-symbols-outlined"
                matTooltip="Not published"
              >visibility_off</mat-icon>
            }
          </td>
        </ng-container>

        <!-- Actions -->
        <ng-container matColumnDef="actions" stickyEnd>
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let organization">
            <div class="d-flex gap-2 justify-content-end organization-list-actions">
              <button
                matIconButton
                matTooltip="Bewerken"
                aria-label="Organisatie bewerken"
                [routerLink]="`/create-edit-organization/${organization.id}`"
              >
                <mat-icon>edit</mat-icon>
              </button>
              <button
                matIconButton
                class="danger-button"
                matTooltip="Verwijderen"
                aria-label="Organisatie verwijderen"
                (click)="deleteOrganization(organization, $event)"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <!-- Header + Row -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          class="organization-list-row"
          *matRowDef="let row; columns: displayedColumns;"
        ></tr>

      </table>
    </div>

    <!-- Paginator -->
    <!-- Sits outside .list-container so it does not travel with the table's horizontal scroll -->
    <mat-paginator
      class="w-100"
      pageSize="10"
      [length]="(dataSource.paginatedData$ | async)?.total"
      [pageSize]="(dataSource.paginatedData$ | async)?.size"
      [pageSizeOptions]="[10, 20, 25, 50, 100]"
      showFirstLastButtons
    ></mat-paginator>

  </mat-card>
</div>
